import { NIP_PL_REGEX } from '@core/const/validator.const';

export const NIP_MASK: Record<string, { mask: string | null; pattern: RegExp }> = {
  pl: {
    mask: '0000000000',
    pattern: NIP_PL_REGEX,
  },
  en: {
    mask: null,
    pattern: null,
  },
};

export const KRS_MASK = '0*';
